import loadScript from "@outdoormap/frontend-utils/js/load-script"

// matomo
;(() => {
  const { matomoDomain, matomoSiteId } = document.body.dataset
  if (!matomoSiteId || !matomoDomain) return

  let scriptLoaded = false

  document.addEventListener(`turbo:load`, function (e) {
    const { guideName, organizationName } = document.body.dataset

    window._paq = window._paq || []

    // push call order matters:

    window._paq.push([`deleteCustomDimension`, 1])
    window._paq.push([`deleteCustomDimension`, 2])

    if (guideName) window._paq.push([`setCustomDimension`, 2, guideName])
    if (organizationName)
      window._paq.push([`setCustomDimension`, 1, organizationName])

    // _paq.push(['setReferrerUrl', currentUrl]);
    window._paq.push([`setCustomUrl`, window.location.pathname])
    window._paq.push([`setDocumentTitle`, document.title])
    window._paq.push([`disableCookies`])
    window._paq.push([`trackPageView`])

    window._paq.push([`enableLinkTracking`])
    window._paq.push([`setTrackerUrl`, `https://${matomoDomain}/matomo.php`])
    window._paq.push([`setSiteId`, matomoSiteId])

    if (!scriptLoaded) {
      loadScript(`https://cdn.matomo.cloud/${matomoDomain}/matomo.js`).then(
        () => (scriptLoaded = true)
      )
    }
  })
})()

// plausible
;(() => {
  const { plausibleDomain } = document.body.dataset
  if (!plausibleDomain) return

  window.plausible =
    window.plausible ||
    function (...args) {
      ;(window.plausible.q = window.plausible.q || []).push(args)
    }

  const script = document.createElement(`script`)
  script.src = `https://plausible.io/js/script.pageview-props.outbound-links.file-downloads.manual.js`
  script.defer = true
  script.dataset.domain = `naturkartan.se`
  document.head.appendChild(script)

  document.addEventListener(`turbo:load`, function () {
    if (!window.plausible) return

    const { guideSlug, countySlug, organizationSlug } = document.body.dataset
    const props = {}

    if (guideSlug) props.guide = guideSlug
    if (countySlug) props.county = countySlug
    if (organizationSlug) props.organization = organizationSlug

    window.plausible(`pageview`, { props })
  })
})()
